/**
 * Browser detection helpers used to tune the UX around native prompts
 * (geolocation, camera) that behave differently on iOS Safari.
 *
 * iOS Safari:
 *   • Does NOT expose `navigator.permissions.query({name:"geolocation"})`.
 *   • The permission prompt appears only ONCE per site.
 *   • Once denied, the user must re-enable it manually from Settings.
 * Because of that, we surface a short hint to iOS users so they know a
 * modal is about to appear.
 */

export const isIOS = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // Classic iOS + modern iPadOS (which reports MacIntel + touch)
  return (
    /iPad|iPhone|iPod/.test(ua)
    || (navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1)
  );
};

export const isIOSSafari = () => {
  if (!isIOS()) return false;
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // On iOS, ALL browsers use WebKit under the hood, but only Safari lacks
  // the alternate UA tokens (CriOS, FxiOS, EdgiOS, OPiOS, ...).
  return !/(CriOS|FxiOS|EdgiOS|OPiOS|GSA|Chrome|Firefox|Edg|OPR)/i.test(ua);
};

/** Best-effort geolocation permission state.
 *  Returns "granted" | "prompt" | "denied" | "unknown".
 */
export const getGeoPermissionState = async () => {
  try {
    if (!navigator?.permissions?.query) return "unknown";
    const st = await navigator.permissions.query({ name: "geolocation" });
    return st.state;
  } catch { return "unknown"; }
};
